import { all, call } from "redux-saga/effects";
import onRecoverPasswordStart from "./forgot-password";
import onResetPasswordStart from "./reset-password";

export default function* passwordRecoverySagas() {
  yield all([call(onRecoverPasswordStart), call(onResetPasswordStart)]);
}
